import { Injectable } from '@angular/core';

import { Language, Region, RidangoReduxAction } from '@ridango/core';

@Injectable()
export class ApplicationActions {
    static SET_PERIOD_TICKET_PROGRESS = '[Application]: Set period ticket progress';
    static SET_WALLET_LOADING_PROGRESS = '[Application]: Set wallet loading progress';
    static SET_REGISTRATION_PROGRESS = '[Application]: Set registration progress';
    static SET_RECOVER_PROGRESS = '[Application]: Set recover progress';
    static SET_LOGGED_IN_CUSTOMER = '[Application]: Set logged in customer';
    static CART_PENDING = '[Application]: Cart pending';
    static SET_PAGE_TITLE = '[Application]: Set page title';
    static SWITCH_HIGH_CONTRAST = '[Application] Switch high contrast';

    static SET_ASSETS_PATH = '[Application] Set Assets Path';

    static SET_PURCHASE_PROGRESS = '[Application]: Set purchase progress';

    static SET_REGION = '[Application]: Set region';
    static SET_SELECTED_LANGUAGE = '[Application]: Set selected language';

    static GET_TERMS_URL = '[Application]: Get terms url';
    static SET_TERMS_URL = '[Application]: Set terms url';
    static SET_USER_AGREED_TERMS_VERSION_ON_ONBOARDING = '[Application]: Set user agreed terms version on onboarding';
    static SET_READY = '[Application]: Set ready';

    setProgress(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_PERIOD_TICKET_PROGRESS,
            payload: payload
        };
    }
    setRegistrationProgress(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_REGISTRATION_PROGRESS,
            payload: payload
        };
    }
    setRecoverProgress(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_RECOVER_PROGRESS,
            payload: payload
        };
    }
    setWalletLoadingProgress(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_WALLET_LOADING_PROGRESS,
            payload: payload
        };
    }
    setLoggedInCustomer(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_LOGGED_IN_CUSTOMER,
            payload: payload
        };
    }
    cartPending(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.CART_PENDING,
            payload: payload
        };
    }

    setPurchaseProgress(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_PURCHASE_PROGRESS,
            payload: payload
        };
    }
    setPageTitle(payload): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_PAGE_TITLE,
            payload: payload
        };
    }

    switchHighContrastMode(): RidangoReduxAction {
        return {
            type: ApplicationActions.SWITCH_HIGH_CONTRAST
        };
    }

    setAssetsPath(path: string): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_ASSETS_PATH,
            payload: path
        };
    }

    setRegion(payload: Region): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_REGION,
            payload: payload
        };
    }

    setSelectedLanguage(payload: Language): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_SELECTED_LANGUAGE,
            payload: payload
        };
    }

    getTermsUrl(): RidangoReduxAction {
        return {
            type: ApplicationActions.GET_TERMS_URL
        };
    }

    setTermsUrl(termsUrl: string): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_TERMS_URL,
            payload: termsUrl
        };
    }

    setReady(ready: boolean): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_READY,
            payload: ready
        };
    }

    setUserAgreedTermsVersionOnOnboarding(version: string): RidangoReduxAction {
        return {
            type: ApplicationActions.SET_USER_AGREED_TERMS_VERSION_ON_ONBOARDING,
            payload: version
        };
    }
}
